import { ctrlTextLen } from '@hlj/hlj-utils'
import { isSiDaProperty } from '@merchant-backend/util'
import Img from '@UI/Img'
import cls from 'classnames'
import { Flex } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import Related from './Related'
import style from './style.module.less'

@inject('decorationStore')
@observer
class Tag extends Component {
  render() {
    const {
      decorationStore: { themeConfig, isThemeBlackGold },
      name
    } = this.props

    return (
      <div
        style={{
          backgroundColor: themeConfig['text'],
          color: isThemeBlackGold ? '#333' : '#fff',
          borderRadius: 2,
          fontSize: 11,
          height: 16,
          lineHeight: '12px',
          marginRight: 6,
          padding: '2px 4px'
        }}
      >
        {name}
      </div>
    )
  }
}

@observer
export default class extends Component {
  getSample() {
    const {
      mode,
      sample_related_work = [],
      media_items = [],
      property_id
    } = this.props

    let sample

    if (isSiDaProperty()) {
      sample = media_items || []
      // 婚纱摄影 如果关联了客照，展示关联客照的前三张详情图片，如果没有关联客照，展示样照详情图片，三张
    } else {
      sample = sample_related_work || []
    }

    const isFake = mode === 'fake'

    if (isFake) {
      return null
    }

    // 20181212-商家主页(直播)优化-芊泽、在下
    // 婚礼摄影、婚礼摄像、婚礼跟妆 不够三张时不展示
    if (isSiDaProperty()) {
      return sample.length >= 3 ? this.getMediaItems(sample) : null
      // 婚纱摄影 如果关联了客照，展示关联客照的前三张详情图片，如果没有关联客照，展示样照详情图片，三张
    } else if (property_id == 6) {
      if (sample.length == 0) {
        return this.getMediaItems(media_items)
      }
    }

    return sample
  }

  getMediaItems = (media = []) => {
    return media.map(({ media_path, cover_path, kind }, i) => {
      // 视频取封面
      return {
        cover_path: kind == 1 ? media_path : cover_path,
        id: i
      }
    })
  }

  // 婚纱摄影： 存在关联客照或者案例图集就展示
  // 其他： 存在关联客照展示，否则不展示
  getShowSample() {
    const {
      sample_related_work = [],
      media_items = [],
      property_id
    } = this.props

    if (property_id == 6) {
      return sample_related_work.length > 0 || media_items.length > 0
    }

    if (isSiDaProperty()) {
      return media_items.length >= 3
    }

    return sample_related_work.length > 0
  }

  render() {
    const {
      cover_path,
      title,
      media_items_pic_count,
      marks,
      mode,
      sample_related_work,
      vertical
    } = this.props

    const imgStyle = {
      width: 342,
      height: 194,
      borderRadius: '15px 15px 0 0',
      backgroundColor: '#eee'
    }

    const isFake = mode === 'fake'

    return (
      <div
        className={style.item}
        style={{
          marginRight: vertical ? 0 : 10,
          marginBottom: vertical ? 16 : 10
        }}
      >
        {isFake ? (
          <div style={imgStyle} />
        ) : (
          <Img
            src={cover_path}
            style={{
              ...imgStyle,
              verticalAlign: 'middle'
            }}
          />
        )}

        <Flex d="v" hc vc className={style.info}>
          {!isFake && this.getShowSample() ? (
            <Related
              is_sample_related_work={(sample_related_work || []).length}
              sample={this.getSample()}
            />
          ) : null}

          {isFake ? (
            <div
              style={{
                width: 250,
                height: 20,
                backgroundColor: '#eee'
              }}
            />
          ) : (
            <div className={cls('text-cut', style.title)}>
              {ctrlTextLen(title, '18', '...')}
            </div>
          )}

          {isFake ? (
            <div
              style={{
                width: 100,
                height: 20,
                backgroundColor: '#eee',
                marginTop: 6
              }}
            />
          ) : (
            <Flex wrap className={style.tags}>
              {(marks || []).map(item => <Tag key={item.id} {...item} />)}

              <Flex vc className={style.views}>
                <img
                  style={{ width: 14, marginRight: 3 }}
                  src="https://qnm.hunliji.com/o_1citj27cc1qcv19691m3b1gckrgt7.png"
                />
                <span className={style.mediaCount}>
                  {media_items_pic_count || 0}
                </span>
              </Flex>
            </Flex>
          )}
        </Flex>
      </div>
    )
  }
}
